import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1 9.5C1 9.77614 1.22386 10 1.5 10C1.77614 10 2 9.77614 2 9.5H1ZM13.5 5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4V5ZM6.77639 3.05279L6.32918 3.27639L6.77639 3.05279ZM7.22361 3.94721L7.67082 3.72361L7.22361 3.94721ZM1 3.5V9.5H2V3.5H1ZM13.5 4H8.11803V5H13.5V4ZM7.67082 3.72361L7.22361 2.82918L6.32918 3.27639L6.77639 4.17082L7.67082 3.72361ZM5.88197 2H2.5V3H5.88197V2ZM7.22361 2.82918C6.96952 2.321 6.45012 2 5.88197 2V3C6.07135 3 6.24448 3.107 6.32918 3.27639L7.22361 2.82918ZM8.11803 4C7.92865 4 7.75552 3.893 7.67082 3.72361L6.77639 4.17082C7.03048 4.679 7.54988 5 8.11803 5V4ZM2 3.5C2 3.22386 2.22386 3 2.5 3V2C1.67157 2 1 2.67157 1 3.5H2Z"
            fill="currentColor"
        />
        <path
            d="M4.26298 7.16366L2.47726 12.1637C2.24468 12.8149 2.72747 13.5 3.419 13.5H11.7953C12.2179 13.5 12.5949 13.2343 12.737 12.8363L14.5227 7.83634C14.7553 7.18509 14.2725 6.5 13.581 6.5H5.20472C4.78211 6.5 4.40512 6.76567 4.26298 7.16366Z"
            stroke="currentColor"
        />
    </svg>
);

export default Icon;
